import {BookingTypeEnum} from 'presentation/pages/private/booking/constants';
import {translations} from 'presentation/translations-new';

const {bookExams, bookOdonto, bookTelehealth} = translations['pt-br'].privateFlow.services;

const getBookingTypeByTitle = (title: string): BookingTypeEnum | undefined => {
	switch (title) {
		case bookTelehealth:
			return BookingTypeEnum.TELEHEALTH;
		case bookExams:
			return BookingTypeEnum.EXAM;
		case bookOdonto:
			return BookingTypeEnum.ODONTO;
		default:
			return undefined;
	}
};

export {getBookingTypeByTitle};
